import type { IParkingInformationWritePayload } from '~/domain/UpdateOffice';
import type { IAddressParkingValues } from '../types/LocationSettings';

/**
 * Free parking sends no cost; paid parking sends the amount and its unit
 * (`'hr'` / `'day'`) exactly as stored, never re-mapped (GOTU-15548).
 */
export const buildParkingInformation = (
  values: IAddressParkingValues,
): IParkingInformationWritePayload => {
  if (values.isParkingFree) {
    return { isParkingFree: true, parkingType: values.parkingType };
  }
  return {
    isParkingFree: false,
    cost: Number(values.parkingCost),
    costType: values.parkingCostType,
    parkingType: values.parkingType,
  };
};
